// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"125":"b202f366930caf9094e0","245":"78dacd3921ee77b51439","522":"5dc7641e97d78b1b0629"}[chunkId] + ".js";
};